// extracted by mini-css-extract-plugin
export default {"root":"_3ufQB","icon":"_3QgMv","tooltip":"_3HrYF"};